import React from 'react';

export const RightArrowIcon = (props) => {
  const { className = '', style = {}, disabled = false, onClick } = props;
  return (
    <svg
      className={className}
      width="10"
      height="15"
      viewBox="0 0 10 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={disabled ? null : onClick}
      style={style}
    >
      <path
        d="M0.930026 3.04206L5.53415 7.64618L0.930026 12.2622C0.405204 12.8706 0.405204 13.7771 0.965809 14.3615C1.57413 15.0056 2.59991 15.0176 3.22016 14.3854L9.95935 7.64618L3.23209 0.918917C2.59991 0.286745 1.58605 0.298672 0.965809 0.942772C0.405204 1.52723 0.405204 2.43375 0.930026 3.04206Z"
        fill="#113E57"
      />
    </svg>
  );
};
